import { useContext } from 'react'

import { MinimizedModalsContext } from '../../context'

export function useMinimizedModalsContext() {
  const context = useContext(MinimizedModalsContext)

  if (!context) {
    throw new Error(
      'useMinimizedModalsContext must be used within MinimizedModalsProvider'
    )
  }

  return context
}
